import ResponsiveMedia from 'components/shared/ResponsiveMedia/ResponsiveMedia';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import type { HeroBentoMediaProps } from './types';

const HeroBentoMedia = ({ sys, media }: HeroBentoMediaProps) => {
  if (!media?.desktopImage?.url) return null;

  return (
    <div
      className="relative h-full w-full overflow-hidden rounded-3xl bg-reserve"
      data-testid="hero-bento-media"
      {...liveUpdateAttrs(sys?.id, 'media')}>
      <ResponsiveMedia
        desktopImage={media.desktopImage}
        mobileImage={media.mobileImage}
        className="h-full w-full [&_img]:h-full [&_img]:w-full [&_img]:object-cover"
      />
    </div>
  );
};

export default HeroBentoMedia;
